import { useEffect, useState } from "react"
import { Card } from "@/components/ui/card"
import { Badge } from "@/components/ui/badge"
import { MessageSquare, Zap } from "lucide-react"

const messages = [
  {
    id: 1,
    text: "Не работает кнопка оплаты",
    source: "Intercom",
    delay: 0,
  },
  {
    id: 2,
    text: "Страница зависает при checkout",
    source: "Zendesk",
    delay: 1500,
  },
  {
    id: 3,
    text: "Ошибка 500 при покупке",
    source: "Help Scout",
    delay: 3000,
  },
  {
    id: 4,
    text: "Не могу завершить заказ",
    source: "Email",
    delay: 4500,
  },
]

export function ChatStreamDemo() {
  const [visibleMessages, setVisibleMessages] = useState<number[]>([])
  const [analyzing, setAnalyzing] = useState(false)
  const [showResult, setShowResult] = useState(false)

  useEffect(() => {
    const timers: ReturnType<typeof setTimeout>[] = []

    messages.forEach((msg) => {
      const timer = setTimeout(() => {
        setVisibleMessages((prev) => [...prev, msg.id])
      }, msg.delay)
      timers.push(timer)
    })

    const analyzeTimer = setTimeout(() => {
      setAnalyzing(true)
    }, 5500)
    timers.push(analyzeTimer)

    const resultTimer = setTimeout(() => {
      setAnalyzing(false)
      setShowResult(true)
    }, 7000)
    timers.push(resultTimer)

    const resetTimer = setTimeout(() => {
      setVisibleMessages([])
      setAnalyzing(false)
      setShowResult(false)
    }, 10000)
    timers.push(resetTimer)

    return () => timers.forEach(clearTimeout)
  }, [visibleMessages.length === 0])

  return (
    <Card className="bg-card p-4 lg:p-6">
      <div className="mb-4 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <MessageSquare className="text-primary h-5 w-5" />
          <h3 className="text-foreground font-semibold">Поток обращений</h3>
        </div>
        <Badge variant="outline" className="animate-pulse">
          Live
        </Badge>
      </div>

      <div className="mb-4 flex min-h-[160px] flex-col gap-2">
        {messages.map((msg) => (
          <div
            key={msg.id}
            className={`bg-muted/50 flex items-center gap-3 rounded-lg p-3 transition-all duration-300 ${
              visibleMessages.includes(msg.id) ? "translate-x-0 opacity-100" : "-translate-x-4 opacity-0"
            }`}
          >
            <Badge variant="secondary" className="shrink-0 text-xs">
              {msg.source}
            </Badge>
            <span className="text-foreground text-sm">{msg.text}</span>
          </div>
        ))}
      </div>

      {analyzing && (
        <div className="bg-primary/5 flex items-center gap-2 rounded-lg p-3">
          <Zap className="text-primary h-4 w-4 animate-pulse" />
          <span className="text-primary text-sm">Анализируем паттерны...</span>
        </div>
      )}

      {showResult && (
        <div className="bg-primary/10 rounded-lg p-3">
          <div className="mb-1 flex items-center gap-2">
            <Zap className="text-primary h-4 w-4" />
            <span className="text-foreground text-sm font-medium">Паттерн обнаружен</span>
          </div>
          <p className="text-muted-foreground text-sm">
            4 обращения объединены в одну проблему: "Ошибка оформления заказа"
          </p>
        </div>
      )}
    </Card>
  )
}
